'use strict';

var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var useIsSSR = require('./useIsSSR.cjs');

function ServerSideSuspense(props) {
  const isSSR = useIsSSR.useIsSSR();
  return isSSR ? /* @__PURE__ */ jsxRuntime.jsx(jsxRuntime.Fragment, { children: props.fallback }) : /* @__PURE__ */ jsxRuntime.jsx(react.Suspense, { ...props });
}

module.exports = ServerSideSuspense;
//# sourceMappingURL=index.cjs.map
